import { MutationTree } from 'vuex';
import { SelectionState } from './types';
import selection, { Selection, Value } from '@/shared/model/selection';

export const mutations: MutationTree<SelectionState> = {
  setSelections(state, payload: Value) {
    state.selections.items = payload.value.map((x) => selection.parse(x));
    state.selections.total = payload['@odata.count'] || 0;
    state.selections.isLoading = false;
  },
  setSelectionsTotal(state, payload: number) {
    state.selections.total = payload;
  },
  setSelectionsIsLoading(state, payload: boolean) {
    state.selections.isLoading = payload;
  },
  setSelectionLocally(state, payload: any) {
    console.log('state.selections.items :>> ', state.selections.items);
    console.log('payload :>> ', payload);

    if (!payload || !payload.id) return;

// Get array from Odata $values
  const unwrap = (obj: any) => {
    if (obj && obj.$values && Array.isArray(obj.$values)) {
      return obj.$values;
    }
    return Array.isArray(obj) ? obj : [];
  };

  
  const cleanedPayload = {
    ...payload,
    articleMarkers: unwrap(payload.articleMarkers),
    modelMarkers: unwrap(payload.modelMarkers),
    colors: unwrap(payload.colors),
  };

    
    const index = state.selections.items.findIndex((item) => item.id === payload.id);
    console.log('index :>> ', index);
    // parse object to comply
    const parsedSelection = selection.parse(cleanedPayload);
    console.log('parsedSelection :>> ', parsedSelection);

    if (index !== -1) {
      // if find replace with reactivity
      state.selections.items.splice(index, 1, parsedSelection);
      console.log(`Selection ${payload.id} updated in state.`);
    } else {
      // // if not found ADD
      // state.selections.items.unshift(parsedSelection);
      // state.selections.total += 1;
      // console.log(`Selection ${payload.id} added to state.`);
    }
  }
};
